import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAvailableCompanies } from 'services/clients/user';
import { Navigate, useNavigate } from 'react-router-dom';
import { Routes } from 'constants/pages';
import { CircularProgress } from '@mui/material';
import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { Header } from 'layouts/SignUpTemplate/components/Header';
import { useUserContext } from 'common/contexts/UserContext';
import { CompanyList } from './CompanyList';

export const JoinCompany: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUserContext();

  const { data, isError, error } = useQuery(
    ['availableCompanies'],
    ({ signal }) => getAvailableCompanies(signal),
    {
      onSuccess: (companies) => {
        if (companies.length === 0) {
          navigate(Routes.CreateCompany);
        }
      },
      // eslint-disable-next-line no-console
      onError: (err) => console.error(err),
    }
  );

  if (user?.signup_status === 'complete') {
    return <Navigate to={Routes.Landing} />;
  }

  let content = (
    <div className="w-full h-full flex items-center justify-center">
      <CircularProgress />
    </div>
  );

  if (isError) {
    // eslint-disable-next-line
    // @ts-ignore
    <div className="text-red-900">{error.message}</div>;
  }

  if (data) {
    content = (
      <>
        <Header
          header="We found your team on BlueCargo!"
          subHeader="Join your team and gain access to container tracking, empty-appointments schedule and
    D&#38;D fighter."
        />
        <CompanyList companies={data} />
      </>
    );
  }

  return (
    <SignUpTemplate>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-[456px] space-y-16">{content}</div>
      </div>
    </SignUpTemplate>
  );
};
JoinCompany.displayName = 'Pages.JoinCompany';
